<template>
  <section class="reservation">
    <div v-if="mode === 'reservation'">
      <div class="reservation_order">
        <transition mode="out-in" @leave="slideUpLeave" @enter="slideUpEnter">
          <reservation-user-needs v-if="orderStatus === 'userNeeds'"></reservation-user-needs>
          <reservation-product-list v-if="orderStatus === 'productsSelection'"></reservation-product-list>
          <reservation-delivery-settings v-if="orderStatus === 'userAddress'"></reservation-delivery-settings>
          <reservation-checkout v-if="orderStatus === 'checkoutForm'"></reservation-checkout>
          <reservation-summary v-if="orderStatus === 'orderSummary'"></reservation-summary>
          <reservation-payment v-if="orderStatus === 'paymentForm'"></reservation-payment>
        </transition>
        <!-- <reservation-checkout></reservation-checkout> -->
      </div>

      <info-helper></info-helper>
    </div>

    <div v-if="mode === 'payment_confirmation'">
      <reservation-thank-you :reservationId="reservationID"></reservation-thank-you>
    </div>

    <div v-if="mode === 'payment_form'">
      <reservation-payment-by-url></reservation-payment-by-url>
    </div>

    <div class="online_notation" v-if="!isOnline">
      <p>Your network connection is broken. Please check it before continuing.</p>
    </div>

    <transition @leave="slideDownLeave" @enter="slideDownEnter">
      <reservation-progress-bar v-if="mode === 'reservation' && orderStep < 6"></reservation-progress-bar>
    </transition>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import gsap from 'gsap'

import ReservationUserNeeds from './reservation/ReservationUserNeeds.vue'
import ReservationProductList from './reservation/ReservationProductsList.vue'
import ReservationDeliverySettings from './reservation/ReservationDeliverySettings.vue'
import ReservationCheckout from './reservation/ReservationCheckout.vue'
import InfoHelper from './dev/InfoHelper.vue'
import ReservationProgressBar from './reservation/ReservationProgressBar.vue'
import ReservationSummary from './reservation/ReservationSummary.vue'
import ReservationPayment from './reservation/ReservationPayment.vue'
import ReservationPaymentByUrl from './reservation/ReservationPaymentByUrl.vue'
import ReservationThankYou from './reservation/ReservationThankYou.vue'

export default {
  name: 'TheReservation',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Reservation',
    // all titles will be injected into this template
    titleTemplate: '%s | LeihBOX',
  },
  data() {
    return {
      isOnline: true,
      mode: 'reservation',
      reservationID: null,
      lastStep: null,
      allowedModes: ['reservation', 'payment_confirmation', 'payment_form'],
    }
  },
  components: {
    ReservationCheckout,
    ReservationProductList,
    ReservationDeliverySettings,
    ReservationUserNeeds,
    InfoHelper,
    ReservationProgressBar,
    ReservationSummary,
    ReservationPayment,
    ReservationPaymentByUrl,
    ReservationThankYou,
  },
  computed: {
    ...mapGetters('cart', ['orderStatus']),
    ...mapState('cart', ['orderStep', 'movingType']),
  },
  created() {
    this.lastStep = this.orderStep

    this.$store.dispatch('user/setCurrentLanguage')
    this.$i18n.locale = this.$store.state.user.currentLanguage

    this.checkPageMode()
    this.$store.dispatch('storages/getSettings')
    this.setInitStep()

    window.addEventListener('online', this.updateIndicator)
    window.addEventListener('offline', this.updateIndicator)
  },
  destroyed() {
    window.removeEventListener('online', this.updateIndicator)
    window.removeEventListener('offline', this.updateIndicator)
  },
  methods: {
    ...mapActions('cart', ['setOrderStep']),
    slideUpLeave(el, done) {
      const direction = this.lastStep < this.orderStep ? '-' : '+'
      if (window.innerWidth < 768) {
        gsap.to(el, { x: `${direction}=100px`, opacity: 0, duration: 0.3, onComplete: () => done() })
      } else {
        gsap.to(el, { y: `${direction}=50px`, opacity: 0, duration: 0.4, onComplete: () => done() })
      }
    },
    slideUpEnter(el, done) {
      const specificElementToAnimation = el.getElementsByClassName('animation_area')
      let elToAnimation = el
      const direction = this.lastStep < this.orderStep ? '+' : '-'

      if (specificElementToAnimation.length) {
        elToAnimation = specificElementToAnimation
      }

      if (window.innerWidth < 768) {
        gsap.from(elToAnimation, {
          x: `${direction}=150px`,
          opacity: 0,
          duration: 0.4,
          onComplete: () => {
            gsap.set(elToAnimation, { clearProps: 'transform' })
            this.lastStep = this.orderStep
            done()
          },
        })
      } else {
        gsap.from(elToAnimation, {
          y: `${direction}=80px`,
          opacity: 0,
          duration: 0.4,
          onComplete: () => {
            gsap.set(elToAnimation, { clearProps: 'transform' })
            this.lastStep = this.orderStep
            done()
          },
        })
      }
    },
    slideDownLeave(el, done) {
      gsap.to(el, { opacity: 0, duration: 0.4, onComplete: () => done() })
    },
    slideDownEnter(el, done) {
      gsap.to(el, { opacity: 1, duration: 0.4, onComplete: () => done() })
    },
    setInitStep() {
      const url_string = window.location.href
      const url = new URL(url_string)
      const initStep = +url.searchParams.get('step')
      if (initStep) {
        this.setOrderStep(initStep)
      }
    },
    checkPageMode() {
      const mode = this.findGetParameter('mode')
      if (mode && this.allowedModes.indexOf(mode) !== -1) {
        this.mode = mode
      }

      this.reservationID = this.findGetParameter('reservation_id')
    },
    findGetParameter(parameterName) {
      var result = null,
        tmp = []
      var items = location.search.substr(1).split('&')
      for (var index = 0; index < items.length; index++) {
        tmp = items[index].split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
      }
      return result
    },
    updateIndicator() {
      if (navigator.onLine) {
        this.isOnline = true
      } else {
        this.isOnline = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.reservation {
  margin-top: 5px;
}

.reservation_order {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.online_notation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 30px;
  background: #ff0000;
  color: #fff;
  text-align: center;

  p {
    font-size: 16px;
  }
}

.flide-up-enter-active,
.flide-up-leave-active {
  transition: opacity s;
}
.flide-up-enter, .flide-up-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
